import Card from "../main/Card"
import "./Main.scss"

const Main = ({data}) =>{
   
    return(
        <>
                <Card data={data}/>
        </>
    )
}

export default Main;